import { jsx as t, jsxs as f, Fragment as eo } from "react/jsx-runtime";
import { useRef as y, useMemo as no, useCallback as lo } from "react";
import { Combobox as C } from "@headlessui/react";
import { usePreventEvent as co, useOnClickOutside as ao } from "@placer-ui/hooks";
import { noop as h } from "lodash/fp";
import { AutoCompleteInput as so } from "./index.es2366.js";
import { AutoCompleteChips as po } from "./index.es2367.js";
import { useAutoComplete as uo } from "./index.es2368.js";
import { AutoCompleteMenu as mo } from "./index.es2369.js";
import { FieldSizeToNumber as io } from "./index.es2370.js";
import { highlightTextWithinItems as fo } from "./index.es547.js";
import a from "./index.es2371.js";
import Co from "classnames";
import { LoadingBar as ho } from "./index.es63.js";
const Do = ({
  items: o,
  placeholder: B,
  value: s = "",
  testId: p,
  inputType: F = "searchfield",
  menuType: L = "multiline",
  disabled: W,
  label: D,
  noResultsItem: S,
  size: x = "default",
  outsideRef: u,
  isClearingOnOutsideClick: T = !1,
  isClearingAfterSelection: k = !1,
  asterix: j,
  feedback: P,
  isError: w,
  required: E,
  maxMenuHeight: b,
  chipsInfo: e,
  onSelectingItem: m = h,
  setValue: n = h,
  isLoading: M = !1,
  openMenuAction: A = "click",
  menuTopPx: R = 0,
  enableLoadingSkeleton: g,
  onFocus: q = h
}) => {
  var v;
  const {
    focused: z,
    open: N,
    internalIsLoading: G,
    onAutoCompleteClick: H,
    onAutoCompleteFocus: J,
    onAutoCompleteSearch: K,
    onAutocompleteClear: Q,
    onClickingOutSide: U,
    onNoResultClick: X,
    setOpen: O,
    onAutoCompleteBlur: Y
  } = uo({
    isClearingOnOutsideClick: T,
    setValue: n,
    items: o,
    value: s,
    openMenuAction: A
  }), i = M || G && z, l = co("contextmenu"), Z = y(null), $ = y([]);
  o != null && o.length && ($.current = o), ao(U, l == null ? void 0 : l.current, u == null ? void 0 : u.current);
  const _ = Co(
    a["combobox-menu"],
    { [a.hasChips]: !!e },
    { [a.noChips]: !e }
  ), I = (v = l.current) == null ? void 0 : v.clientWidth, V = {
    "--top": `${io[x] + 6 + R}px`,
    "--maxWidth": `${I}px`,
    "--maxHeight": b ? `${b}px` : "unset"
  }, oo = no(
    () => fo({ searchTerm: s, items: o || [] }),
    [o, s]
  ), ro = lo(
    (r) => {
      if (!r.isDisabled) {
        if (typeof r.label == "string")
          n(r.label), m({ ...r, isSelected: !0 });
        else {
          const c = o == null ? void 0 : o.find((d) => (d == null ? void 0 : d.value) === (r == null ? void 0 : r.value));
          c && (n((c == null ? void 0 : c.label) || ""), m({ ...c, isSelected: !0 }));
        }
        O(!1), k && n("");
      }
    },
    [O, k, n, o, m]
  ), to = e ? N : N && (o === void 0 || !!(o != null && o.length));
  return /* @__PURE__ */ t("span", { className: a.searchRoot, "data-testid": `${p}-autocomplete-root`, ref: l, children: /* @__PURE__ */ f(C, { children: [
    /* @__PURE__ */ f(C.Input, { className: a.input + " pl-auto-complete", as: "span", children: [
      /* @__PURE__ */ t(
        so,
        {
          placeholder: B,
          inputType: F,
          size: x,
          value: s,
          ref: Z,
          label: D,
          disabled: W,
          asterix: j,
          feedback: P,
          isError: w,
          required: E,
          testId: `${p}-search-field`,
          onClear: Q,
          onClick: A === "click" ? H : void 0,
          setValue: K,
          onFocus: (r) => {
            J(), q(r);
          },
          onBlur: Y
        }
      ),
      i && /* @__PURE__ */ t(ho, {})
    ] }),
    to && /* @__PURE__ */ t(
      C.Options,
      {
        as: "span",
        className: _,
        static: !0,
        "data-testid": `${p}-options-menu`,
        style: V,
        children: /* @__PURE__ */ f(eo, { children: [
          e && /* @__PURE__ */ t(po, { ...e }),
          /* @__PURE__ */ t(
            mo,
            {
              items: i && g ? $.current : oo,
              menuType: L,
              noResultsItem: S,
              onMenuItemClick: ro,
              onNoResultClick: X,
              activeLoadingSkeleton: i && g
            }
          )
        ] })
      }
    )
  ] }) });
};
export {
  Do as BaseAutoComplete
};
//# sourceMappingURL=index.es565.js.map
